import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, take } from "rxjs/operators";

import { ignoreNil } from "@triparound/trp-components/shared";

import { CommonFacadeService } from "../@core/services/common-facade.service";
import { NavigationFacadeService } from "../@core/services/navigation-facade.service";

import { AuthenticationFacadeService } from "./authentication-facade.service";

@Injectable()
export class LoggedInAuthenticationGuard {
	isGuestValidationActive$: Observable<boolean>;

	constructor(
		private authenticationFacade: AuthenticationFacadeService,
		private navigationFacade: NavigationFacadeService,
		private commonFacade: CommonFacadeService,
	) {
		this.isGuestValidationActive$ = this.authenticationFacade.isGuestValidationActive$;
	}

	canActivate(): Observable<boolean> {
		return this.isGuestValidationActive$.pipe(
			ignoreNil(),
			take(1),
			map(isGuestValidationActive => {
				const user = this.authenticationFacade.getUserData();
				if (isGuestValidationActive) {
					if (this.authenticationFacade.isUserValidated(user?.uuid || null)) {
						this.navigationFacade.go({
							path: [`${this.commonFacade.loginUrl}/${user?.uuid}/welcome`],
						});
						return false;
					}
					return true;
				}
				this.navigationFacade.go({
					path: [`${this.commonFacade.loginUrl}/${user?.uuid}/welcome`],
				});
				return false;
			}),
			catchError(() => of(true)),
		);
	}
}
